<script lang="ts">
    import type {Injector, LocalizeFunction} from '../svelte/types';
    import {getContext} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../svelte/utils';
    import KpDataDisplayer from '../commons/ui-components/table/KpDataDisplayer.svelte';
    import type {DataDisplayerSettings} from '../typings/portaro.fe.types';
    import {DataDisplayerOptions} from '../typings/portaro.fe.types';
    import type {Fond, RecordExport, RecordOperationType} from '../typings/portaro.be.types';
    import {RecordExportService} from './record-export.service';
    import {uuid} from '../shared/utils/custom-utils';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const service: RecordExportService = injector.getByToken(RecordExportService.serviceName);
    let dataDisplayer: KpDataDisplayer;

    const handleEdit = async (event: CustomEvent<RecordExport>) => {
        await service.edit(event.detail);
        dataDisplayer.loadAll();
    }

    const create = async () => {
        await service.create({id: uuid(), confirmed: false});
        dataDisplayer.loadAll();
    }

    const settings = {
        options: [DataDisplayerOptions.Edit],
        loadAll: () => service.getAll(),
        columnsSetting: [
            {title: '#', key: 'id'},
            {title: localize( /* @kp-localization export.request.oaiSetId */ 'export.request.oaiSetId'), key: 'oaiSetId'},
            {title: localize( /* @kp-localization export.request.oaiSetName */ 'export.request.oaiSetName'), key: 'oaiSetName'},
            {
                title: 'pouze operace',
                key: 'recordOperationTypes',
                valueModifier: (value: RecordOperationType[]) => value.map((v) => v.id).join(',')
            },
            {
                title: localize( /* @kp-localization commons.Fondy */ 'commons.Fondy'),
                key: 'fonds',
                valueModifier: (value: Fond[]) => value.map((v) => v.id).join(',')
            },
            {
                title: localize( /* @kp-localization commons.Departments */ 'commons.Departments'),
                key: 'rootDepartments',
                valueModifier: (value: Fond[]) => value.map((v) => v.id).join(',')
            },
            {title: 'vč. periodik', key: 'withPerio'},
            {title: 'vč. neperiodik', key: 'withNonperio'},
            {title: 'vč. bez exemplářů', key: 'withNonexemplared'},
            {title: 'vyloučené záznamy', key: 'forbiddenRecordIds'},
            {title: 'custom sql', key: 'sqlClause'},
        ]
    } as DataDisplayerSettings;

</script>

<div class="row">
    <div class="col-xs-12">
        <h1>Exporty (OAI, NCIP, ...)</h1>
        <button type="button" class="btn btn-primary btn-sm pull-right" on:click={create}>
            <span class="glyphicon glyphicon-plus"></span>
            &nbsp;
            Vytvořit nový
        </button>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <KpDataDisplayer {settings} on:edit={handleEdit} bind:this={dataDisplayer}/>
        </div>
    </div>
</div>